import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import Axios from "../apis/axios";
import { NodeId } from "components/NodeId";
import { produce } from "immer";



const createAreaSlice = (set: (data: any) => void, get: () => any) => ({
  //Start of areaConfig
  createAreaConfig: async (payload:any) => {


     const commandObjects: any[] = [];

    const areaCommandObject: any = {
      nodeId: payload.nodeid ? payload.nodeid : "",
      payload: payload,
      type: "create",
      task: "processCreateAreaConfigCommand",
    };
    commandObjects.push(areaCommandObject);
   
    const promises = await get().enqueueCommands(commandObjects);

    return promises;
  },

  processCreateAreaConfigCommand: async (
    commandObject: any
  ) => {
    try {
    

      const response = await Axios.post(
        "api/v1/area/create",
        commandObject.payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );

      if (response && response?.status === 200) {
       
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      
      throw new Error(String(error));
    }
  },


      //Start of siteConfig
      updateAreaConfig: async (nodeid:any, payload:any) => {
    
        if (payload.lang === undefined) {
          payload.lang = get().lang;
        }
    
        if (nodeid === "") {
          nodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
        }
    
        
    
         const commandObjects: any[] = [];
    
        const siteCommandObject: any = {
          nodeId: nodeid ? nodeid : "",
          payload: payload,
          type: "put",
          task: "processUpdateAreaConfigCommand",
        };
        commandObjects.push(siteCommandObject);
        
        const promises = await get().enqueueCommands(commandObjects);
    
        return promises;
      },
    
      processUpdateAreaConfigCommand: async (
        commandObject: any
      ) => {
        try {
  
          const encodedReportNodeId = encodeURIComponent(
            commandObject.nodeId || ""
          );
  
        
    
          const response = await Axios.put(
            "api/v1/areas/"+encodedReportNodeId,
            commandObject.payload,
            {
              headers: {
                "Content-Type": "application/json",
              },
              timeout: 10000,
            }
          );
    
          if (response && response?.status === 200) {
            
            return response.data;
          } else {
            throw new Error();
          }
        } catch (error) {
         
          throw new Error(String(error));
        }
      },


  deleteAreaConfiguration: async (payload: any) => {
    const deleteCommandObject = {
      payload: payload,
      type: "delete",
      task: "processDeleteAreaConfigCommand",
    };
    let promises = get().enqueueCommands([deleteCommandObject]);

    return promises;
  },

  processDeleteAreaConfigCommand: async (
    commandObject: any
  ) => {
    try {
      
      const encodedAreaNodeId = encodeURIComponent(
        commandObject.payload.areanodeid || ""
      );
      const response = await Axios.delete(
        "/api/v1/areas/" + encodedAreaNodeId,
        {
          data:{
            legalentitynodeid:commandObject.payload.legalentitynodeid
          },
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );

      if (response && response?.status === 200) {
      
        return;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

});



export default createAreaSlice;
